export const loadUserRequest = (data) => ({
  type: 'LOAD_USER',
  payload: data,
})

export const unloadUserRequest = () => ({
  type: 'UNLOAD_USER',
})
